import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import uk from "./locales/uk.json";
import ru from "./locales/ru.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import pt from "./locales/pt.json";
import de from "./locales/de.json";
import pl from "./locales/pl.json";
import sk from "./locales/sk.json";
import it from "./locales/it.json";
import nl from "./locales/nl.json";
import ro from "./locales/ro.json";
import tr from "./locales/tr.json";
import ar from "./locales/ar.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import id from "./locales/id.json";
import vi from "./locales/vi.json";

// Языки — тот же набор, что на dronedefender.eu (18). Порядок: прежние шесть, затем новые.
export const LANGS = [
  { code: "en", label: "EN" },
  { code: "uk", label: "УКР" },
  { code: "ru", label: "РУС" },
  { code: "fr", label: "FR" },
  { code: "es", label: "ES" },
  { code: "pt", label: "PT" },
  { code: "de", label: "DE" },
  { code: "pl", label: "PL" },
  { code: "sk", label: "SK" },
  { code: "it", label: "IT" },
  { code: "nl", label: "NL" },
  { code: "ro", label: "RO" },
  { code: "tr", label: "TR" },
  { code: "ar", label: "العربية" },
  { code: "ja", label: "日本語" },
  { code: "ko", label: "한국어" },
  { code: "id", label: "ID" },
  { code: "vi", label: "VI" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      uk: { translation: uk },
      ru: { translation: ru },
      fr: { translation: fr },
      es: { translation: es },
      pt: { translation: pt },
      de: { translation: de },
      pl: { translation: pl },
      sk: { translation: sk },
      it: { translation: it },
      nl: { translation: nl },
      ro: { translation: ro },
      tr: { translation: tr },
      ar: { translation: ar },
      ja: { translation: ja },
      ko: { translation: ko },
      id: { translation: id },
      vi: { translation: vi },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "uk", "ru", "fr", "es", "pt", "de", "pl", "sk", "it", "nl", "ro", "tr", "ar", "ja", "ko", "id", "vi"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "dd_lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
